const request = require("request");

const address = {};

address.region1 = [
    "서울", "경기", "강원", "충북", "충남", "경북", "경남", "전북", "전남", "인천", "대전", "대구", "광주", "울산", "부산", "제주", "세종"
];

address.region2 = {
    "서울": [
        "종로구", "중구", "용산구", "성동구", "광진구", "동대문구", "중랑구", "성북구", "강북구", "도봉구", "노원구",
        "은평구", "서대문구", "마포구", "양천구", "강서구", "구로구", "금천구", "영등포구", "동작구", "관악구", "서초구",
        "강남구", "송파구", "강동구" ],
    "경기": [
        "수원시", "성남시", "의정부시", "안양시", "부천시", "광명시", "평택시", "동두천시", "안산시", "고양시", "과천시",
        "구리시", "남양주시", "오산시", "시흥시", "군포시", "의왕시", "하남시", "용인시", "파주시", "이천시", "안성시",
        "김포시", "화성시", "광주시", "양주시", "포천시", "여주시", "연천군", "가평군", "양평군" ],
    "강원": [
        "춘천시", "원주시", "강릉시", "동해시", "태백시", "속초시", "삼척시", "홍천군", "횡성군", "영월군", "평창군",
        "정선군", "철원군", "화천군", "양구군", "인제군", "고성군", "양양군" ],
    "충북": [
        "청주시", "충주시", "제천시", "보은군", "옥천군", "영동군", "증평군", "진천군", "괴산군", "음성군", "단양군" ],
    "충남": [
        "천안시", "공주시", "보령시", "아산시", "서산시", "논산시", "계룡시", "당진시", "금산군", "부여군", "서천군",
        "청양군", "홍성군", "예산군", "태안군" ],
    "전북": [
        "전주시", "군산시", "익산시", "정읍시", "남원시", "김제시", "완주군", "진안군", "무주군", "장수군", "임실군",
        "순창군", "고창군", "부안군" ],
    "전남": [
        "목포시", "여수시", "순천시", "나주시", "광양시", "담양군", "곡성군", "구례군", "고흥군", "보성군", "화순군",
        "장흥군", "강진군", "해남군", "영암군", "무안군", "함평군", "영광군", "장성군", "완도군", "진도군", "신안군" ],
    "경북": [
        "포항시", "경주시", "김천시", "안동시", "구미시", "영주시", "영천시", "상주시", "문경시", "경산시", "군위군", "의성군",
        "청송군", "영양군", "영덕군", "청도군", "고령군", "성주군", "칠곡군", "예천군", "봉화군", "울진군", "울릉군" ],
    "경남": [
        "창원시", "진주시", "통영시", "사천시", "김해시", "밀양시", "거제시", "양산시", "의령군", "함안군", "창녕군",
        "고성군", "남해군", "하동군", "산청군", "함양군", "거창군", "합천군" ],
    "인천": ["중구", "동구", "미추홀구", "연수구", "남동구", "부평구", "계양구", "서구", "강화군", "옹진군"],
    "대전": [ "동구", "중구", "서구", "유성구", "대덕구" ],
    "대구": [ "중구", "동구", "서구", "남구", "북구", "수성구", "달서구", "달성군", "군위군" ],
    "광주": [ "동구", "서구", "남구", "북구", "광산구" ],
    "울산": [ "중구", "남구", "동구", "북구", "울주군" ],
    "부산": [
        "중구", "서구", "동구", "영도구", "부산진구", "동래구", "남구", "북구", "해운대구", "사하구", "금정구", "강서구",
        "연제구", "수영구", "사상구", "기장군" ],
    "제주": [ "제주시", "서귀포시" ],
    "세종": [
        "반곡동", "소담동", "보람동", "대평동", "가람동", "한솔동", "나성동", "새롬동", "다정동", "어진동", "종촌동",
        "고운동", "아름동", "도담동", "산울동", "해밀동", "합강동", "집현동", "세종동", "누리동", "한별동", "다솜동",
        "용호동", "조치원읍", "연기면", "연동면", "부강면", "금남면", "장군면", "연서면", "전의면", "전동면", "소정면", ],
};

const getRegion1 = function(name) {
    if (/서울/.test(name)) return "서울";
    else if (/경기/.test(name)) return "경기";
    else if (/강원/.test(name)) return "강원";
    else if (/충청북도|충북/.test(name)) return "충북";
    else if (/충청남도|충남/.test(name)) return "충남";
    else if (/경상북도|경북/.test(name)) return "경북";
    else if (/경상남도|경남/.test(name)) return "경남";
    else if (/전라북도|전북/.test(name)) return "전북";
    else if (/전라남도|전남/.test(name)) return "전남";
    else if (/인천/.test(name)) return "인천";
    else if (/대전/.test(name)) return "대전";
    else if (/대구/.test(name)) return "대구";
    else if (/광주/.test(name)) return "광주";
    else if (/울산/.test(name)) return "울산";
    else if (/부산/.test(name)) return "부산";
    else if (/제주/.test(name)) return "제주";
    else if (/세종/.test(name)) return "세종";
    return "";
};

const getRegion2 = function(name1, name2) {
    if (name1) {
        const names = name1.split(' ');
        if (names && names.length > 0) {
            return names[0];
        }
    }
    if (name2) {
        const names = name2.split(' ');
        if (names && names.length > 0) {
            return names[0];
        }
    }
    return "";
};

address.search = function(addressText, onResponse) {

    const option = {
        uri: "https://dapi.kakao.com/v2/local/search/address.json",
        qs: { query: addressText, },
        headers: {
            "Authorization": "KakaoAK 08d325a2ac35b7581743a929e05a3c05"
        },
        encoding:"utf-8",
    };
    
    request(option, (err, res, body) => {
        const result = {};
        const addressDatas = JSON.parse(body).documents;
        if (addressDatas.length > 0) {
            console.log(addressDatas);
            const data = addressDatas[0].address;
            result.region1 = getRegion1(data.region_1depth_name),
            result.region2 = getRegion2(data.region_2depth_name, data.region_3depth_name),

            // console.log(result.region1);
            // console.log(result.region2);
            result.addressX = data.x;
            result.addressY = data.y;
        } else {
            console.log(addressText);
            const addressSplits = addressText.split(' ');
            if (addressSplits.length > 0) {
                result.region1 = getRegion1(addressSplits[0]);
                if (address.region2[result.region1] && address.region2[result.region1].includes(addressSplits[1])) {
                    result.region2 = addressSplits[1];
                    result.addressX = "0";
                    result.addressY = "0";
                }
            }
        }

        if (result.region1 && result.region2 && result.addressX && result.addressY) {
            onResponse("", result.region1, result.region2, result.addressX, result.addressY);
        } else {
            onResponse("주소를 찾을 수 없습니다!");
        }
    });
}

address.install = function(Vue) {
    Vue.prototype.$address = address;
}

export default address;


// WEBPACK FOOTER //
// ./src/address.js